import { render, staticRenderFns } from "./TheSnapshotAppIframe.vue?vue&type=template&id=3c8b10a2&scoped=true&"
import script from "./TheSnapshotAppIframe.vue?vue&type=script&lang=js&"
export * from "./TheSnapshotAppIframe.vue?vue&type=script&lang=js&"
import style0 from "./TheSnapshotAppIframe.vue?vue&type=style&index=0&id=3c8b10a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8b10a2",
  null
  
)

export default component.exports